import React from "react";

const LogoutIcon = ({
  color = "#2B363B",
  width = 18,
  height = 18,
  opacity = 0.75,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 25"
    role="img"
    aria-label="Icono logout"
    {...props}
  >
    <path
      stroke={color}
      strokeOpacity={opacity}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m10 17.62 5-5-5-5M15 12.62H3M15 3.62h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
    />
  </svg>
);

export default LogoutIcon;
